<template>
  <div class="codeCase">
    <img class="leftImg" src="../../assets/images/sc_1@2x.png" style="width: 151px;height: 433px;position: absolute;top: 0px;left: 0px;z-index: -1;">
    <div style="font-size: 40px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #1F2329;line-height: 56px;text-align: center;">他们都在用日化标识码</div>
    <div style="width: 1440px;margin: 60px auto 0;box-sizing: border-box;padding: 0 100px;display: flex;justify-content: space-between;position: relative;height: 500px;">

      <img src="../../assets/images/sc_3@2x.png" style="width: 100px;height: 48px;position: absolute;bottom: 75px;right: 130px;">
      <el-carousel indicator-position="outside" style="width: 100%;height: 450px;">
        <el-carousel-item style="width: 100%;height: 430px;">
          <div style="display: flex;justify-content: space-between;cursor: pointer;height: 430px;z-index: 99;background: #fff;align-items: center;padding: 0 5px;">

            <div class="list" style="width: 400px;height: 380px;border: 2px solid #fff;border-radius: 10px;box-shadow: 0px 2px 10px 0px rgba(193,194,224,0.5);padding: 38px 30px;box-sizing: border-box;position: relative;" v-for="(item, index) in pageList" :key="index" @click="tabData(index)">
              <img src="../../assets/images/yinhao.png" style="width: 25px;height: 21px;position: absolute;right: 17px;">
              <img :src="item.pic" style="width: 76px;height: 76px;margin-bottom: 14px;">
              <div style="font-size: 16px;font-family: FZQKBYSJW--GB1-0, FZQKBYSJW--GB1;font-weight: normal;color: #1E232A;line-height: 34px;width: 100%;text-overflow: -o-ellipsis-lastline;overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 5;line-clamp: 5;-webkit-box-orient: vertical;height: 170px;">
                {{item.content}}
              </div>
              <div style="text-align: right;margin-top: 20px;font-size: 14px;font-family: PingFang-SC-Medium, PingFang-SC;font-weight: 500;color: #1E232A;">{{item.title}}</div>
            </div>
          </div>

        </el-carousel-item>
      </el-carousel>


      <!-- <el-carousel indicator-position="outside">
        <el-carousel-item v-for="(item, index) in pageList" :key="index">
          <div style="display: flex;justify-content: space-between;align-items: center;padding: 0 100px;">
            <div style="margin-right: 20px;">
              <div style="font-size: 28px;font-family: FZQKBYSJW--GB1-0,FZQKBYSJW--GB1;font-weight: 400;color: #3c424c;line-height: 58px;letter-spacing: 1px;">
                {{item.content}}
              </div>
              <div style="font-size: 21px;font-family: PingFang-SC-Medium,PingFang-SC;font-weight: 400;color: #9098a4;line-height: 28px;text-align: right;">{{item.title}}</div>
            </div>
            <img :src="item.pic" style="width: 297px;height: 272px;">
          </div>
        </el-carousel-item>
      </el-carousel> -->
    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        pageList: [{
          content: '日化标识码是一款一站式全流程防伪营销系统，基于国家标识的名片码、产品码为顾客复购和营销裂变增加了很多场景，日化标识码，真的可以定义新的营销方式。',
          title: '——周正 潞安娜销售总监',
          pic: require('../../assets/images/luanna.png')
        },{
          content: '皙肽的每一件产品都赋予了工信部授权的一物一码标识码，帮助企业进行获客以及精细化运营，从而促进业务增长。通过给皙肽产品赋码，标识码扫码率达到了40%，带来了近15%的复购率增长。',
          title: '——中国日用化学工业研究院',
          pic: require('../../assets/images/xitai.png')
        },{
          content: 'BOSS端管理APP解决了多年来数据无法追溯的问题，日化标识码是一股新势力，未来，他可以领航美业防伪营销数据管理一体化。',
          title: '——韩冠生物CEO',
          pic: require('../../assets/images/hanguan.png')
        }],
        isactive: 0
      }
    },
    methods: {
      tabData(index) {
        this.isactive = index
      }
    }
  }
</script>

<style scoped>
 /* @media (max-width: 1500px) {
    .leftImg {
      left: 0;
    }
  }

  @media (min-width: 1500px) {
.leftImg {
      left: 0;
    }
  } */
  .codeCase {
    height: 690px;
    padding: 65px 0;
    box-sizing: border-box;
    position: relative;
  }

  .el-carousel__item:nth-child(2n) {
    /* background-color: #99a9bf; */
    width: 100% !important;
    height: 430px !important;
  }

  .el-carousel__item:nth-child(2n+1) {
    /* background-color: #d3dce6; */
    width: 100% !important;
    height: 430px !important;
  }

  /deep/ .el-carousel {
    width: 100% !important;
  }

  /deep/ .el-carousel > .el-carousel__container {
    width: 100% !important;
  }

  /deep/ .el-carousel__item {
    width: 100% !important;
  }

  .active {
    border: 2px solid #578BFF !important;
  }

  /deep/ .el-carousel__indicators--outside {
    position: absolute !important;
    bottom: 0px;
  }

  .list:hover {
    border: 2px solid #1ED2C7 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/components/CodeCase.vue